import { InputBarcodeComponent } from './input-barcode.component';

export default angular
  .module('sfMobile.components.input-barcode', ['sfMobile.services.barcode'])
  .component('sfInputBarcode', InputBarcodeComponent).name;
